window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

(() => {
  const waitForProductFormSwitchText = () => {
    const productFormSwitchText = document.querySelectorAll(".product-form-switch-text:not(.product-form-switch-text-no-dynamic-udpate) > div:first-child ");
    if (productFormSwitchText.length > 0) {
      //check if all product.selling_plan_groups and get the last whose app_id is "bundlesubscriptions", and get that name
      const sellingPlanGroups = product.selling_plan_groups;
      const bundleSubscriptionGroup = sellingPlanGroups.find((group) => group.app_id === "bundlesubscriptions");
      const bundleSubscriptionName = bundleSubscriptionGroup ? bundleSubscriptionGroup.name : null;

      productFormSwitchText.forEach((el) => {
        if (bundleSubscriptionName) {
          el.innerText = bundleSubscriptionName;
        }
        el.classList.add("updated");
      });
    } else {
      setTimeout(waitForProductFormSwitchText, 100);
    }
  };

  waitForProductFormSwitchText();
})();